import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "modal_button",
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal"
}
const _hoisted_2 = {
  class: "modal fade",
  id: "modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered modal-dialog-custom" }
const _hoisted_4 = { class: "modal-content d-flex flex-column modal-container" }
const _hoisted_5 = { class: "d-flex header justify-content-between" }
const _hoisted_6 = {
  class: "modal-title fs-5",
  id: "exampleModalLabel"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "footer d-flex justify-content-center" }




export default /*@__PURE__*/_defineComponent({
  __name: 'InfoModalComponent',
  props: {
    header: {
        type: String,
        required: true
    },
    body: {
        type: String,
        required: true
    },
    buttonText: {
        type: String,
        required: true
    }
},
  emits: [
    'onButtonClick'
],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

__expose({
    show
});

function show() {
    const modalButton = document.getElementById('modal_button');
    modalButton?.click();
}

function onButtonClick() {
    emit('onButtonClick');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("button", _hoisted_1, null, 512), [
      [_vShow, false]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(props.header), 1),
            _cache[0] || (_cache[0] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", {
            class: "content",
            innerHTML: props.body
          }, null, 8, _hoisted_7),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              onClick: onButtonClick,
              type: "button",
              class: "btn add-to-cart-button align-self-end"
            }, _toDisplayString(props.buttonText), 1)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})